<template>
  <div class="info">
    <div class="pdf_box">
      <el-dialog
        title="预览"
        :visible.sync="pdfFlag"
        width="700px"
        top="1vh"
      >
        <video
          v-if="infoArr.goodsType==4"
          :src="infoArr.fileUrl"
          width="100%"
          controls="controls"
          id="myvideo"
          muted
          autoplay="autoplay"
        ></video>
        <iframe
          v-if="goodsType==2||goodsType==3||goodsType==5"
          frameborder="0"
          style="width: 100%;margin-top: -1%"
          :src="infoArr.fileUrl"
          width="100%"
          height="990px"
        >
        </iframe>
      </el-dialog>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="350px"
    >
      <h2>联系客服：400-000-3877</h2>
      <h2>开通服务</h2>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <div>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: myRouter }">{{infoArr.goodsType|changeType}}</el-breadcrumb-item>
        <el-breadcrumb-item>{{infoArr.systemName}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="center_box">
      <div>
        <div class="tag">
          <div
            v-for="item in infoArr.flagList"
            :key="item.id"
          >{{item.flagName}}
          </div>
        </div>
        <div class="title">
          {{infoArr.systemName}}
        </div>
        <div class="other_title">
          <div>{{infoArr.createTime|changeTime}} 上传 | {{infoArr.previewNum}}阅读 | {{infoArr.downloadNum}}次已下载</div>
          <div>
            <div>
              <el-button
                size="small"
                v-if="goodsType==1"
                @click="toUse()"
              >立即使用</el-button>
              <span v-else-if="goodsType==5"></span>
              <el-button
                size="small"
                @click="look(infoArr.id)"
                v-else
              >查看全部</el-button>

            </div>
            <div>￥{{infoArr.goodsPrices}}</div>
          </div>
        </div>
        <div class="img_box">
          <div
            v-if="goodsType==4"
            style="width:100%"
          >
            <video
              :src="infoArr.fileUrl"
              width="100%"
              id="myvideo"
              muted
              @play="playVideo()"
              autoplay="autoplay"
            ></video>
          </div>
          <pdf
            :url="infoArr.fileUrl"
            v-else-if="goodsType==2||goodsType==3"
          ></pdf>
          <div v-else-if="goodsType==5">
            <el-carousel height="467px">
              <el-carousel-item
                v-for="item in imgBox"
                :key="item"
              >
                <img
                  width="100%"
                  height="100%"
                  :src="item"
                  alt=""
                >
              </el-carousel-item>
            </el-carousel>
          </div>
          <img
            width="700px"
            height="467px"
            v-else
            :src="infoArr.pictureUrl"
            alt=""
          >
        </div>
      </div>
      <div class="right_box">
        <div>
          <el-button
            type="primary"
            @click="use(infoArr.id)"
            v-if="goodsType==1"
          >立即试用</el-button>
          <el-button
            type="primary"
            @click="download(infoArr.id)"
            v-else
          >立即下载</el-button>
          <span>
            <img
              v-if="infoArr.collectionFlag==1"
              @click="collection(infoArr.id)"
              src="../img/bigsc2.png"
              alt=""
            >
            <img
              v-else
              src="../img/bigsc1.png"
              alt=""
            >
          </span>

        </div>
        <div style="word-wrap: break-word;
white-space: normal;
word-break: break-all;">
          {{infoArr.systemContent}}
        </div>
      </div>
    </div>
    <div class="bottom_box">
      <div>
        <div>猜你喜欢</div>
        <div @click="changeLove()"><i class="el-icon-refresh-right"></i> 换一换</div>
      </div>
      <div class="img_list">
        <div
          v-for="item in loveList"
          :key="item.id"
          @click="goInfo(item)"
        >
          <img
            :src="item.pictureUrl"
            alt=""
          >
          <div class="img_list_content">
            <div>{{item.systemName}}</div>
            <div>{{item.systemContent}}</div>
            <div>
              <div>￥{{item.goodsPrices}}</div>
              <div>{{item.goodsType|changeType}}</div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import pdf from "../components/pdf.vue";
import { collection, download, look, getLoveList,getInfo} from "../js/api.js";
export default {
  components: {
    pdf,
  },
  data() {
    return {
      dialogVisible: false,
      infoArr: {},
      runHtml: "123123",
      searchForm: {
        goodsId: "",
        pageNum: 1,
        pageSize: 5,
      },
      myRouter:"",
      totalPage: 0,
      loveList: [],
      pdfFlag: false,
      goodsType: "",
      imgBox: [],
    };
  },
  created() {
    this.myRouter = '/'+sessionStorage.getItem('router')
    this.load();
  },
  methods: {
    //立即使用
    toUse() {
      this.dialogVisible = true;
    },
    async load() {
      let res = await getInfo(this.$route.query.id);
      if (res.data.code == 200) {
        // console.log(this.$route.query.userId)
      // this.infoArr = JSON.parse(sessionStorage.getItem("infoArr"));
      // this.infoArr = JSON.parse(this.$route.query.id)
      
       this.infoArr = res.data.data
       let imgBox = [];
      for (let i in this.infoArr) {
        if (
          i == "pictureUrl" ||
          i == "previewPicture0" ||
          i == "previewPicture1" ||
          i == "previewPicture2" ||
          i == "previewPicture3" ||
          i == "previewPicture4" ||
          i == "previewPicture5" ||
          i == "previewPicture6" ||
          i == "previewPicture7" ||
          i == "previewPicture8" ||
          i == "previewPicture9"
        ) {
          if (this.infoArr[i] != null) {
            imgBox.push(this.infoArr[i]);
          }
        }
      }
      this.imgBox = imgBox;
      this.searchForm.goodsId = this.infoArr.id;
      this.goodsType = this.infoArr.goodsType;
      this.getLoveList(this.searchForm);
      if (document.compatMode == "BackCompat") {
        document.body.scrollTop = top;
      } else {
        if (document.documentElement.scrollTop == 0) {
          document.body.scrollTop = top;
        } else {
          document.documentElement.scrollTop = top;
        }
      }
      }
    },
    playVideo() {
      var myvideo = document.getElementById("myvideo");
      myvideo.addEventListener("timeupdate", () => {
        if (myvideo.currentTime > 5) {
          myvideo.pause();
          // 这里写你的弹窗提示
        }
      });
    },
    //跳转详情页面
    goInfo(e) {
      sessionStorage.setItem("infoArr", JSON.stringify(e));
      this.load();
      this.$router.push({
        path: "/infoPage",
        query: {
          id: e.id
        },
      });
    },
    //换一换
    changeLove() {
      if (this.searchForm.pageNum >= this.totalPage) {
        this.searchForm.pageNum = 1;
      } else {
        this.searchForm.pageNum = this.searchForm.pageNum + 1;
      }
      this.getLoveList(this.searchForm);
    },
    //喜欢列表
    async getLoveList(data) {
      let res = await getLoveList(data);
      if (res.data.code == 200) {
        this.totalPage = res.data.paging.totalPage;
        this.loveList = res.data.paging.list;
      }
    },
    //查看全部
    async look(id) {
      let res = await look(id);
      if (res.data.code == 401) {
        window.location.href = res.data.data;
      } else if (res.data.code == 200) {
        if (res.data.data.flag == 1) {
          this.pdfFlag = true;
        } else {
          this.runHtml = res.data.data.data;
          var win = window.open("", "运行窗口");
          win.document.open();
          win.document.write(this.runHtml);
          win.document.close();
        }
      }
    },
    //立即使用
    async use(id) {
      let res = await download(id);
      if (res.data.code == 401) {
        window.location.href = res.data.data;
      } else if (res.data.code == 200) {
        if (res.data.data.flag == 1) {
          var tempwindow = window.open("_blank");
          tempwindow.location.href = this.infoArr.systemUrl;
        } else {
          this.runHtml = res.data.data.data;
          var win = window.open("", "运行窗口");
          win.document.open();
          win.document.write(this.runHtml);
          win.document.close();
        }
      }
    },
    //下載
    async download(id) {
      let res = await download(id);
      if (res.data.code == 401) {
        window.location.href = res.data.data;
      } else if (res.data.code == 200) {
        if (res.data.data.flag == 1) {
          window.location.href =
            "http://103.239.204.52:16000/zk/goods/downloadFile/" +
            this.infoArr.id;
        } else {
          this.runHtml = res.data.data.data;
          var win = window.open("", "运行窗口");
          win.document.open();
          win.document.write(this.runHtml);
          win.document.close();
        }
      }
    },
    //收藏
    async collection(id) {
      let res = await collection(id);
      if (res.data.code == 401) {
        window.location.href = res.data.data;
      } else if (res.data.code == 200) {
        this.infoArr.collectionFlag = 2;
        this.$message({
          showClose: true,
          message: res.data.message,
          type: "success",
        });
      }
    },
  },
  filters: {
    changeType(val) {
      if (val == 1) {
        return "演示系统";
      } else if (val == 2) {
        return "设计方案";
      } else if (val == 3) {
        return "宣传画册";
      } else if (val == 4) {
        return "演示视频";
      } else if (val == 5) {
        return "其他";
      } else {
        return "全部";
      }
    },
    changeTime(val) {
      var date = new Date(val); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D = date.getDate() < 10 ? "0" + date.getDate() + " " : date.getDate();
      var h =
        date.getHours() < 10
          ? "0" + date.getHours() + ":"
          : date.getHours() + ":";
      var m =
        date.getMinutes() < 10
          ? "0" + date.getMinutes() + ":"
          : date.getMinutes() + ":";
      var s =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return Y + M + D;
    },
  },
};
</script>

<style scoped>
.info {
  width: 1200px;
  margin: auto;
  font-size: 16px;
}

.center_box {
  display: flex;
  justify-content: space-between;
  padding: 20px;
}

.center_box > div:first-child {
  width: 750px;
  padding: 10px 10px;
  box-sizing: border-box;
  background: #fff;
}

.center_box > div:last-child {
  width: 400px;
  padding: 60px 20px;
  box-sizing: border-box;
  background: #fff;
}

.tag {
  /* display: flex; */
}

.tag > div {
  border: 1px solid #2563e4;
  float: left;
  border-radius: 20px;
  padding: 3px 10px;
  font-size: 13px;
  margin-top: 10px;
  margin-right: 10px;
  color: #2563e4;
}

.title {
  font-size: 28px;
  font-weight: 500;
  margin: 10px 0;
  clear: both;
}

.other_title {
  color: #a3a3a3;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.other_title > div {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.other_title /deep/ .el-button {
  background: transparent;
  color: #2563e4;
  border: 1px solid #2563e4;
  font-size: 14px;
  padding: 5px 10px;
}

.other_title > div:last-child > div:last-child {
  color: #fe5c05;
  font-family: STHeiti;
  font-size: 25px;
  margin-left: 20px;
}

.img_box {
  position: relative;
}

.img_box img {
  width: 100%;
}

.right_box > div:first-child {
  display: flex;
}

.right_box /deep/ .el-button {
  width: 250px;
  height: 60px;
  font-size: 20px;
  background: #2563e4;
}

.right_box img {
  margin-left: 20px;
  width: 60px;
  height: 60px;
  cursor: pointer;
}

.right_box > div:last-child {
  margin-top: 30px;
  text-indent: 2em;
  line-height: 35px;
  font-size: 15px;
  color: #7a7a7a;
}

.bottom_box {
  padding: 0 20px;
}

.bottom_box > div {
  padding: 10px 30px;
  align-items: center;
  color: #474747;
  background: #fff;
}

.bottom_box > div:first-child {
  justify-content: space-between;
  display: flex;
}

.bottom_box > div:first-child > div:first-child {
  font-size: 20px;
}

.bottom_box > div:first-child > div:last-child {
  cursor: pointer;
}

.img_list {
  box-sizing: border-box;
}

.img_list > div {
  float: left;
  margin-left: 10px;
  width: 210px;
  height: 300px;
  cursor: pointer;
}

.img_list > div:hover {
  transition: all 1s;
  transform: scale(1.05);
  -ms-transform: scale(1.05); /* IE 9 */
  -moz-transform: scale(1.05); /* Firefox */
  -webkit-transform: scale(1.05); /* Safari and Chrome */
  -o-transform: scale(1.05); /* Opera */
}

.img_list img {
  width: 210px;
  height: 140px;
}

.img_list_content {
  padding: 5px 10px;
}

.img_list_content > div:first-child {
  line-height: 30px;
}

.img_list_content > div:nth-child(2) {
  font-size: 13px;
  word-break: break-all;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-height: 25px;
  -webkit-box-orient: vertical;
  height: 78px;
}

.img_list_content > div:nth-child(3) {
  display: flex;
  justify-content: space-between;
  margin-top: 5px;
}

.img_list_content > div:nth-child(3) > div:first-child {
  color: #fe5c05;
  font-family: STHeiti;
  font-size: 18px;
}

.img_list_content > div:nth-child(3) > div:last-child {
  color: #2563e4;
  border: 1px solid #2563e4;
  font-size: 13px;
  padding: 2px 5px;
  border-radius: 5px;
  cursor: pointer;
}

h2 {
  width: 100%;
  text-align: center;
  margin: 10px 0;
  color: #2563e4;
}
</style>